// Assuming this is a Lit component where your navigation is defined
import { LitElement, html, css } from 'lit';
import { state, queryAll, customElement } from 'lit/decorators.js';
import { router, resolveRouterPath } from '../router'; // Adjust the path to your router.ts
import '@web.awesome.me/webawesome-pro/dist/components/button/button.js';
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js';

@customElement('app-navigation')
export class MyNavigation extends LitElement {
  static styles = css`
    @media only screen and (max-width: 768px) {
      .navigation {
        display: none;
      }
      .fab {
        display: block !important;
      }
    }
    .fab {
      display: none;
    }
    /* Your navigation styles */
    .navigation-item.active .navigation-text,
    .navigation-item.active .navigation-icon {
      color: var(--wa-color-brand-50);
    }
    wa-button wa-icon[slot="start"] {
      background: var(--wa-color-surface-raised);
      border-radius: 50%;
      padding: .25rem;
    }

    .navbar {
      display: flex;
      justify-content: center;
      padding: 0rem 0.5rem;
      align-items: flex-start;
      gap: 0.5rem;
      background: var(--wa-color-surface-lowered);
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .navbar-item {
      display: flex;
      padding: 1rem 0;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.25rem;
      flex: 1 0 0;
    }
    .item-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 1rem;
      background: transparent;
      border: 2px solid transparent;
    }
    .navbar-item.active .item-container {
      background: var(--wa-color-brand-90) !important;
      border: 2px solid var(--wa-color-brand-50);
    }
    .navbar-item:hover .item-container,
    .navbar-item.active:hover .item-container {
      background: var(--wa-color-surface-border) !important;
    }
    .item-container-label {
      align-self: stretch;
      color: var(--wa-color-text-normal);
      text-align: center;
      @media (max-width: 950px) {
        display: none !important;
      }
    }
    .state-layer {
      display: flex;
      width: 4rem;
      @media (max-width: 950px) {
        width: 2rem !important;
      }
      height: 2rem;
      padding: 0.25rem 1.25rem;
      justify-content: center;
      align-items: center;
    }
    .navbar-icon {
      flex-shrink: 0;
    }
    .navbar-icon::part(base) {
      color: var(--wa-color-text-normal);
    }
    .navbar-icon wa-icon {
      font-size: 1.75rem;
    }
  `;

  @state() isDrawerOpen = false; //Add a state to track if the drawer is open.

  @state()
  private currentPathname: string = window.location.pathname;

  @queryAll('.navbar-item')
  private navigationItems!: NodeListOf<HTMLElement>;

  firstUpdated() {
    router.addEventListener('route-change', () => {
      this.currentPathname = window.location.pathname;
      this._updateActiveLink();
    });
    this._updateActiveLink(); // Set initial active link on load
  }

  private _updateActiveLink() {
    this.navigationItems.forEach(item => {
      const linkButton = item.querySelector('wa-button');
      const href = linkButton?.getAttribute('href');
      const resolvedHref = href ? resolveRouterPath(href.startsWith('/') ? href.substring(1) : href) : ''; // Resolve relative paths

      if (resolvedHref === this.currentPathname) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }



  render() {
    return html`
      <div class="navbar">
        <div class="navbar-item">
          <div class="item-container">
            <div class="state-layer">
              <wa-button appearance="plain" href="/game-tracker" class="navbar-icon">
                <wa-icon src="/assets/svg/bcore.svg" label="Tournament"></wa-icon>
              </wa-button>
            </div>
          </div>
          <div class="item-container-label">
            Tournament
          </div>
        </div>
        <div class="navbar-item">
          <div class="item-container">
            <div class="state-layer">
              <wa-button appearance="plain" href="/counter" class="navbar-icon">
                <wa-icon src="/assets/svg/cmd.svg" label="Commander"></wa-icon>
              </wa-button>
            </div>
          </div>
          <div class="item-container-label">
            Commander
          </div>
        </div>
        <div class="navbar-item">
          <div class="item-container">
            <div class="state-layer">
              <wa-button appearance="plain" href="/" class="navbar-icon">
                <wa-icon src="/assets/svg/wizards-of-the-coast-brands.svg" label="Dashboard"></wa-icon>
              </wa-button>
            </div>
          </div>
          <div class="item-container-label">
            Dashboard
          </div>
        </div>
        <div class="navbar-item">
          <div class="item-container">
            <div class="state-layer">
              <wa-button appearance="plain" href="/standard-tracker" class="navbar-icon">
                <wa-icon src="/assets/svg/shield-halved-solid.svg" label="Match play"></wa-icon>
              </wa-button>
            </div>
          </div>
          <div class="item-container-label">
            Match Play
          </div>
        </div>
        <div class="navbar-item">
          <div class="item-container">
            <div class="state-layer">
              <wa-button appearance="plain" href="/app-roll-dice" class="navbar-icon">
                <wa-icon src="/assets/svg/dice-d20-solid.svg" label="Roll dice"></wa-icon>
              </wa-button>
            </div>
          </div>
          <div class="item-container-label">
            Roll
          </div>
        </div>
      </div>
    `;
  }
}
